import { render } from "./confirm-delete-session.vue?vue&type=template&id=8505193a&lang=pug"
import script from "./confirm-delete-session.vue?vue&type=script&lang=js"
export * from "./confirm-delete-session.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__